import { Component } from "@angular/core";
import { Title } from "@angular/platform-browser";

@Component({
    selector: 'unit-three-lesson-four-landing-page',
    templateUrl: '../../_shared/landing-pages/landing-page.component.html',
    styleUrls: ['../../_shared/landing-pages/landing-page.component.css']
})
export class UnitThreeLessonFourLandingComponent {

    bannerHeader = "Work-Based Learning Experiences: Lesson 4";
    title: string = "Lesson 4: Job Shadowing";
    pageTitle: string = "Job Shadowing | Unit 3, Lesson 4 | T-Folio";

    openInNewWindow(url: string) {
        window.open(url, '_blank');
    }
    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
    doPrint(): void {
        window.print();
    }

    LandingPageData = {
        breadcrumbs: {
            label: "Lesson 4",
            crumbs: [
                {
                    route: "",
                    linktext: "T-Folio"
                },
                {
                    route: "/unit-3",
                    linktext: "Unit 3"
                }
            ]
        },
        summary: "In this lesson, youth will be guided through the activities in the Job Shadow Workbook in order to set up and conduct a job shadowing experience.",
        objectives: [
            "Learn what it means to shadow someone on a job.",
            "Connect with someone to job shadow.",
            "Develop a set of questions to ask during the job shadow.",
            "Conduct a job shadow and follow-up activities."
        ],
        buttons: [
            {
                route: "/unit-3/lesson-4/guide",
                linktext: "Lesson Guide",
                color: "btn-success",
                window: false,
            },
            {
                route: "/unit-3/lesson-4/job-shadow-workbook",
                linktext: "Job Shadow Workbook",
                color: "btn-primary",
                window: false,
            },
            {
                route: '/img/unit-3/lesson-4/T-Folio_Unit-3_Lesson-4_Job-Shadowing.pptx',
                linktext: "PowerPoint Presentation",
                color: "powerpoint-button",
                window: true,
            }
        ],
        image: "/img/unit-3/lesson-4/LESSON 4_shop-2649775_1920.jpg",
        imgalt: "An older person wearing works goggles and an apron stands to the left of a younger person wearing work goggles, red safety earmuffs, and an apron as they both look at work equipment in a mechanic shop.",
        caption: "on ",
        photoLink: "https://pixabay.com/en/shop-mentor-construction-saw-2649775/",
        source: "Pixabay",
        sourceLink: "https://pixabay.com/en/",
        licence: "CC0 license",
        licenceLink: "https://creativecommons.org/publicdomain/zero/1.0/",
    }
}
